export const getStringFromGenresArray = (
    genres: string[] | undefined
): string | undefined => {
    if (genres) {
        const genresString = genres.join(', ')
        return genresString
    }
}
